// src/Pages/Landing/JoyrideKantaHameLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideKantaHameLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Kanta-Häme"
      cities={[
        "Hämeenlinna",
        "Riihimäki",
        "Forssa",
        "Janakkala",
        "Hattula",
        "Loppi",
        "Tammela"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Kanta-Hämeen alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Hämeenlinnan, Riihimäen ja Forssan seutu sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}